import { Source } from '@reelmachine/core';

/** Pause between two starts of a batch, so a batch does not hit the model quota all at once. */
export const BATCH_GAP_MS = 20_000;
export const BATCH_MAX = 30;

/**
 * Sources of a batch paste. Blocks separated by a line "---" are one source each: a block that is only a link
 * becomes a link, anything else a text. Without separators, every link in the paste is one source, also links glued
 * to text ("Skript fertighttps://..."), as in lists copied from chat.
 */
export function parseBatch(input: string): Source[] {
  const blocks = input
    .split(/^\s*-{3,}\s*$/m)
    .map((b) => b.trim())
    .filter(Boolean);
  const out: Source[] = [];
  const seen = new Set<string>();
  const push = (s: Source) => {
    if (seen.has(s.value)) return;
    seen.add(s.value);
    out.push(s);
  };
  if (blocks.length > 1) {
    for (const b of blocks) {
      const asLink = /^https?:\/\/\S+$/.test(b) ? Source.safeParse({ type: 'link', value: b }) : undefined;
      const parsed = asLink?.success ? asLink : Source.safeParse({ type: 'text', value: b });
      if (parsed.success) push(parsed.data);
    }
    return out;
  }
  for (const m of input.matchAll(/https?:\/\/[^\s<>"')\]]+/g)) {
    const value = m[0].replace(/[.,;:!?]+$/, '');
    const parsed = Source.safeParse({ type: 'link', value });
    if (parsed.success) push(parsed.data);
  }
  return out;
}
